
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25.4","height":"39.5","viewBox":"0 0 25.4 39.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#324997","d":"M16.2 19.8L1.5 34.5c-.2.2-.2.6 0 .9l3.1 3.1c.2.2.6.2.9 0l18.4-18.2c.2-.2.2-.6 0-.9L5.6 1.1C5.5 1 5.3.9 5.2.9c-.2 0-.3.1-.4.2L1.7 4.2c-.4.3-.4.7-.1 1l14.6 14.6z"}})])
          )
        }
      }
    